// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subhead-common{height:14px;line-height:14px}.subhead-common .left,.subhead-common .right{float:left}.subhead-common .left{width:3px;height:14px;margin-right:10px}.subhead-common .right{color:#333}", ""]);
// Exports
module.exports = exports;
